const COUNTRY_ID_LIST = {
  JPN: 1,
  CHN: 2
}

export default {
  COUNTRY_ID_LIST
}
